<template>
  <SectionCard :id="section.id" :title="section.title">
    <div :id="section.subSections.overview.id" class="commitment-overview">
      <AppTable>
        <thead>
          <tr>
            <th>Egen insats</th>
            <th>Ansökt lånebelopp</th>
            <th>Beviljat lånebelopp</th>
            <th>Bostadens uppskattade pris</th>
          </tr>
        </thead>
        <tbody>
          <AppTableRow>
            <AppTableCell>{{ formatAmountWithCurrency(commitment.statedCashContribution) }}</AppTableCell>
            <AppTableCell>{{ formatAmountWithCurrency(commitment.amountAppliedFor) }}</AppTableCell>
            <AppTableCell>{{ formatAmountWithCurrency(commitment.amountApproved) }}</AppTableCell>
            <AppTableCell>{{ formatAmountWithCurrency(propertyValue) }}</AppTableCell>
          </AppTableRow>
        </tbody>
      </AppTable>
      <div>
        <AppButton
          small
          :loading="isKalpLoading"
          :disabled="!kalp"
          :title="kalpError || undefined"
          @click="openKalpModal"
        >
          Visa KALP-beräkning
        </AppButton>
      </div>
    </div>
  </SectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { SectionCard, AppButton, AppTable, AppTableRow, AppTableCell, useModal } from '@staff/ui'
import { formatAmountWithCurrency, toNumericValue } from '@staff/shared'
import { useApplicationKalpContext, useRequiredCommitment } from '@/views/application/application.context'
import type { ApplicationSections } from './sections'
import KalpModalContent from '../KalpModalContent.vue'

defineProps<{
  section: ApplicationSections['commitmentDetails']
}>()

const commitment = useRequiredCommitment()

const propertyValue = computed(() => toNumericValue(commitment.value.propertyEstimation?.value))

const { kalp, isKalpLoading, kalpError } = useApplicationKalpContext()
const { openModal } = useModal()

// The button stays disabled until the calculation exists, so the modal can take
// plain snapshots — nothing inside it can change the data while it is open.
const openKalpModal = () => {
  if (!kalp.value) return

  openModal(
    'Kvar att leva på kalkyl (KALP)',
    KalpModalContent,
    { application: commitment.value, kalp: kalp.value },
    { size: 'large' },
  )
}
</script>

<style scoped lang="scss">
.commitment-overview {
  display: grid;
  gap: var(--space-24);
}
</style>
